import { FormattedCurrency } from '@iwIntlProvider/FormattedCurrency';
import { TopupPendingSVG } from '@svgComponents/TopupPendingSVG/TopupPendingSVG';
import { FormattedMessage } from 'react-intl';

import DashboardCTA from '../../dashboardComponents/DashboardCTA/DashboardCTA';

type TopUpPendingProps = {
    requestedCashAmount?: number;
    requestedAmount?: number;
};

export const TopUpPending = ({
    requestedCashAmount,
    requestedAmount
}: TopUpPendingProps) => {
    return (
        <DashboardCTA
            data-testid="top-up-pending"
            icon={<TopupPendingSVG />}
            title={
                <FormattedMessage
                    id="_.dashboard_widget.topUpPending.title"
                    defaultMessage="Additional funds requested"
                />
            }
            description={
                requestedCashAmount ? (
                    <FormattedMessage
                        id="_.dashboard_widget.topUpPending.description"
                        defaultMessage="Thanks for your application for an additional {amount}. We’ll aim to get back to you in 24 hours but please bear with us if we take a little longer."
                        values={{
                            amount: (
                                <strong>
                                    <FormattedCurrency
                                        value={requestedCashAmount}
                                    />
                                </strong>
                            )
                        }}
                    />
                ) : (
                    <FormattedMessage
                        id="_.dashboard_widget.topUpPending.descriptionFallback"
                        defaultMessage="Thanks for your application for a top up to a credit limit of {amount}. We’ll aim to get back to you in 24 hours but please bear with us if we take a little longer."
                        values={{
                            amount: (
                                <strong>
                                    <FormattedCurrency
                                        value={requestedAmount!}
                                    />
                                </strong>
                            )
                        }}
                    />
                )
            }
        />
    );
};
